/* Progressive enhancements; product purchasing remains in its own Shopify section. */
(() => {
  function init() {
    const sticky = document.querySelector('[data-hp-mobile-cta]');
    const hero = document.querySelector('.hp-hero');
    const footer = document.querySelector('.hn-footer');
    if (!sticky || !hero || !('IntersectionObserver' in window) || sticky.dataset.initialized) return;
    sticky.dataset.initialized = 'true';
    let heroVisible = true;
    let footerVisible = false;
    const update = () => { sticky.hidden = heroVisible || footerVisible; };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === hero) heroVisible = entry.isIntersecting;
        if (entry.target === footer) footerVisible = entry.isIntersecting;
      });
      update();
    });
    observer.observe(hero);
    if (footer) observer.observe(footer);
    document.querySelectorAll('a[href="#question-fer"]').forEach(link => {
      link.addEventListener('click', () => {
        const question = document.getElementById('question-fer');
        if (question) question.open = true;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
